import { render } from "./TableAdressen.vue?vue&type=template&id=39dacd79"
import script from "./TableAdressen.vue?vue&type=script&lang=js"
export * from "./TableAdressen.vue?vue&type=script&lang=js"

import "./TableAdressen.vue?vue&type=style&index=0&id=39dacd79&lang=css"

import exportComponent from "C:\\Users\\benja\\Desktop\\SKWinkelStarter\\Frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__